import axios from '../../axios'

/*
 * 角色数据接口
 */

// 获取角色列表
export const getRoleList = (data) => {
    return axios({
        url: '/api/admin/role',
        method: 'get',
        data
    })
}

// 获取角色权限ID列表
export const getRolePermList = (data) => {
    return axios({
        url: '/api/admin/rolePermList',
        method: 'get',
        data
    })
}
// 新增角色信息
export const saveRole = (data) => {
    return axios({
        url: '/api/admin/role',
        method: 'post',
        data
    })
}

// 编辑角色信息
export const updateRole = (data) => {
    return axios({
        url: '/api/admin/role',
        method: 'put',
        data
    })
}

// 删除角色列表
export const deleteRole = (data) => {
    return axios({
        url: '/api/admin/role',
        method: 'delete',
        data
    })
}

// 获取机构列表
export const getAgentListByProvince = (data) => {
    return axios({
        url: '/api/base/province_agent',
        method: 'get',
        data
    })
}

// 获取全部渠道码列表
export const getAllChannelData = (data) => {
    return axios({
        url: '/api/admin/allChannelList',
        method: 'get',
        data
    })
}

// 获取全部渠道码列表（父渠道下有子渠道列表）
export const getAllChannels = (data) => {
    return axios({
        url: '/api/admin/allChannels',
        method: 'get',
        data
    })
}

// 获取所有第三方小程序码
export const allSourceList = (data) => {
    return axios({
        url: '/api/admin/allSourceList',
        method: 'get',
        data
    })
}




// WEBPACK FOOTER //
// ./src/http/moudules/sys/role.js